import { Component, Input } from "@angular/core";

@Component({
    selector: 'colored-skill',
    templateUrl: './colored-skill.component.html',
    styleUrls: ['./colored-skill.component.scss'],
})
export class ColoredSkill {
    private val: number
    
    @Input() 
    set value(value: number) {
        this.val = value;
    }

    get value(): number {
        return this.val;
    }
}